import {
  ApplicationTypeEnum,
  CustomerDTO,
  CustomerEventTypeEnum,
  CustomerGroupEnum,
  CustomerPoolEnum,
  CustomerStateEnum,
} from './api';

const customerStateMapping: Record<CustomerStateEnum, string> = {
  [CustomerStateEnum.UNKNOWN]: '未知',
  [CustomerStateEnum.BLACK_LIST]: '黑名单',
  [CustomerStateEnum.WAIT_FOLLOW_UP]: '待跟进',
  [CustomerStateEnum.UNQUALIFIED]: '资质不符合',
  [CustomerStateEnum.WAIT_SIGN]: '待签约',
  [CustomerStateEnum.SIGNED]: '已签约',
  [CustomerStateEnum.VISITED]: '已上门',
  [CustomerStateEnum.APPROVAL]: '审核中',
  [CustomerStateEnum.LOAN]: '已放款',
  [CustomerStateEnum.EXAMINING]: '在审件',
  [CustomerStateEnum.INVALID]: '捣乱申请',
};

const customerGroupMapping: Record<CustomerGroupEnum, string> = {
  [CustomerGroupEnum.NEW_CUSTOMER]: '新客户',
  [CustomerGroupEnum.NEW_ALLOT]: '新分派',
  [CustomerGroupEnum.EXPAND]: '拓展',
  [CustomerGroupEnum.MORTGAGE]: '抵押',
  [CustomerGroupEnum.LOCKED]: '锁定',
  [CustomerGroupEnum.A]: 'A 类',
  [CustomerGroupEnum.B]: 'B 类',
  [CustomerGroupEnum.C]: 'C 类',
  [CustomerGroupEnum.D]: 'D 类',
  [CustomerGroupEnum.E]: 'E 类',
};

const filterCustomGroupMapping = (
  group: CustomerGroupEnum,
  appType?: ApplicationTypeEnum,
) => {
  if (appType === ApplicationTypeEnum.LOAN || !appType) {
    return true;
  }
  return [
    CustomerGroupEnum.NEW_CUSTOMER,
    CustomerGroupEnum.NEW_ALLOT,
    CustomerGroupEnum.LOCKED,
    CustomerGroupEnum.A,
    CustomerGroupEnum.B,
  ].includes(group);
};

const customerEventMapping: Record<CustomerEventTypeEnum, string> = {
  [CustomerEventTypeEnum.COMMENT]: '备注',
  [CustomerEventTypeEnum.DROP_PUBLIC_POOL]: '抛入公共池',
  [CustomerEventTypeEnum.BLOCK_CALL]: '未接通',
  [CustomerEventTypeEnum.CALL]: '打电话',
  [CustomerEventTypeEnum.REASSIGN]: '重新分派',
  [CustomerEventTypeEnum.VISIT]: '上门',
  [CustomerEventTypeEnum.LOAN]: '放款',
  [CustomerEventTypeEnum.REDUPLICATE]: '重复申请',
  [CustomerEventTypeEnum.REMARK]: '领导点评',
  [CustomerEventTypeEnum.INTO_BIZ]: '进入业务池',
  [CustomerEventTypeEnum.CUSTOMER_HISTORY]: '客户变化',
  [CustomerEventTypeEnum.RMS_PUSH]: 'RMS推送进业务池',
};

const customerPoolMapping: Record<CustomerPoolEnum, string> = {
  [CustomerPoolEnum.PUBLIC]: '公共池',
  [CustomerPoolEnum.BIZ]: '业务池',
  [CustomerPoolEnum.WAIT_HANDLE]: '待处理',
  [CustomerPoolEnum.IDLE]: '空闲',
};

const extraKeys = {
  isNative: '本地人',
  hasCar: '车',
  hasHouse: '本地房',
  hasProvidentFund: '公积金',
  hasSocialSecurity: '社保',
  hasBusinessLicense: '营业执照',
  hasThreeCredit: '三地合一',
};

const generateExtra = (
  keys?: Pick<
    CustomerDTO,
    | 'hasBusinessLicense'
    | 'isNative'
    | 'hasCar'
    | 'hasHouse'
    | 'hasProvidentFund'
    | 'hasSocialSecurity'
    | 'hasThreeCredit'
  >,
) => {
  const extra: string[] = [];
  Object.keys(extraKeys).forEach((key) => {
    // @ts-ignore
    if (keys && key in keys && keys[key]) {
      extra.push(key);
    }
  });
  return extra;
};

const flatDepartment = (department?: I.Department) => {
  if (!department) {
    return [];
  }
  const result = [department];
  if (department.parent) {
    result.push(...flatDepartment(department.parent));
  }
  return result;
};

export {
  customerStateMapping,
  customerGroupMapping,
  customerEventMapping,
  customerPoolMapping,
  flatDepartment,
  generateExtra,
  extraKeys,
  filterCustomGroupMapping,
};
